/* eslint-disable */
// All of this code is copy pasted from the old direct.universal.soy template
export function addFbPixelScript(f, b, e, v, n, t, s) {
  if (f.fbq) {
    return
  }
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq) {
    f._fbq = n
  }
  n.push = n
  n.loaded = !0
  n.version = '2.0'
  n.queue = []
  t = b.createElement(e)
  t.async = !0
  t.src = v
  s = b.getElementsByTagName(e)[0]
  s.parentNode.insertBefore(t, s)
}

export function addTikTokAnalytics(w, d, t) {
  w.TiktokAnalyticsObject = t
  var ttq = (w[t] = w[t] || [])
  ttq.methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie',
  ]
  ttq.setAndDefer = function (t, e) {
    t[e] = function () {
      t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
    }
  }
  for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i])
  ttq.instance = function (t) {
    for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n])
    return e
  }
  ttq.load = function (e, n) {
    var i = 'https://analytics.tiktok.com/i18n/pixel/events.js'
    ;(ttq._i = ttq._i || {}),
      (ttq._i[e] = []),
      (ttq._i[e]._u = i),
      (ttq._t = ttq._t || {}),
      (ttq._t[e] = +new Date()),
      (ttq._o = ttq._o || {}),
      (ttq._o[e] = n || {})
    n = document.createElement('script')
    ;(n.type = 'text/javascript'), (n.async = !0), (n.src = i + '?sdkid=' + e + '&lib=' + t)
    e = document.getElementsByTagName('script')[0]
    e.parentNode.insertBefore(n, e)
  }
}

export function addTwitterAnalyticsScript(e, t, n, s, u, a) {
  e.twq ||
    ((s = e.twq =
      function () {
        s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments)
      }),
    (s.version = '1.1'),
    (s.queue = []),
    (u = t.createElement(n)),
    (u.async = !0),
    (u.src = 'https://static.ads-twitter.com/uwt.js'),
    (a = t.getElementsByTagName(n)[0]),
    a.parentNode.insertBefore(u, a))
}

export function addSegmentAnalyticsScript() {
  var analytics = (window.analytics = window.analytics || [])
  if (!analytics.initialize)
    if (analytics.invoked) window.console && console.error && console.error('Segment snippet included twice.')
    else {
      analytics.invoked = !0
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
        'addSourceMiddleware',
        'addIntegrationMiddleware',
        'setAnonymousId',
        'addDestinationMiddleware',
      ]
      analytics.factory = function (e) {
        return function () {
          var t = Array.prototype.slice.call(arguments)
          t.unshift(e)
          analytics.push(t)
          return analytics
        }
      }
      for (var e = 0; e < analytics.methods.length; e++) {
        var key = analytics.methods[e]
        analytics[key] = analytics.factory(key)
      }
      analytics.load = function (key, e) {
        var t = document.createElement('script')
        t.type = 'text/javascript'
        t.async = !0
        t.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js'
        var n = document.getElementsByTagName('script')[0]
        n.parentNode.insertBefore(t, n)
        analytics._loadOptions = e
      }
    }
}

export function addAdrollAnalyticsScript(adrollAdvId, adrollPixId) {
  window.adroll_adv_id = `${adrollAdvId}`
  window.adroll_pix_id = `${adrollPixId}`
  window.adroll_version = '2.0'
  ;(function (w, d, e, o, a) {
    w.__adroll_loaded = true
    w.adroll = w.adroll || []
    w.adroll.f = ['setProperties', 'identify', 'track']
    var roundtripUrl = 'https://s.adroll.com/j/' + window.adroll_adv_id + '/roundtrip.js'
    for (a = 0; a < w.adroll.f.length; a++) {
      w.adroll[w.adroll.f[a]] =
        w.adroll[w.adroll.f[a]] ||
        (function (n) {
          return function () {
            w.adroll.push([n, arguments])
          }
        })(w.adroll.f[a])
    }

    e = d.createElement('script')
    o = d.getElementsByTagName('script')[0]
    e.async = 1
    e.src = roundtripUrl
    o.parentNode.insertBefore(e, o)
  })(window, document)
}
/* eslint-enable */
